import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { TodoItem } from "@/components/TodoItem";
import type { Todo } from "@/App";

interface SortableItemProps {
	todo: Todo;
	onToggle: (id: string) => void;
	onDelete: (id: string) => void;
	onEdit: (id: string, text: string) => void;
}

export function SortableItem({
	todo,
	onToggle,
	onDelete,
	onEdit,
}: SortableItemProps) {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({ id: todo.id });

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		opacity: isDragging ? 0.4 : 1,
	};

	return (
		<div ref={setNodeRef} style={style} {...attributes}>
			<TodoItem
				todo={todo}
				onToggle={onToggle}
				onDelete={onDelete}
				onEdit={onEdit}
				dragHandleProps={listeners}
			/>
		</div>
	);
}
